import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, SvgIcon, Text } from "@cinch-labs/design-system";
import Image from "next/image";
import styles from "./partner-card.module.css";
var PartnerCard = function(param) {
    var body = param.body, heading = param.heading, logo = param.logo, url = param.url, innerRef = param.innerRef;
    var ref = _sliced_to_array(url || [], 1), link = ref[0];
    var _alt;
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.logoWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: logo.filename,
                    alt: (_alt = logo.alt) !== null && _alt !== void 0 ? _alt : undefined,
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.inner,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h3",
                        className: styles.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.text,
                        children: body
                    }),
                    link.url ? /*#__PURE__*/ _jsxs("a", {
                        href: link.url.cached_url,
                        className: styles.link,
                        target: "_blank",
                        ref: innerRef,
                        rel: "noreferrer",
                        "aria-label": heading === "TRNSMT" ? "Visit Transmit official site" : "",
                        children: [
                            link.text,
                            /*#__PURE__*/ _jsx(SvgIcon, {
                                name: "arrow-right",
                                className: styles.externalLinkIcon
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
export default PartnerCard;
